import React, { useState } from 'react';
import './PasswordReset.css'; // Include your CSS file

export default function PasswordReset() {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [messageType, setMessageType] = useState(""); // To track message type (success or error)

  const setVal = (e) => {
    setEmail(e.target.value);
  };

  const handleReset = async (e) => {
    e.preventDefault();
    try {
      const res = await fetch("https://backend.ems.uk.hiradentallab.com/api/user/sendpasswordlink", {
        method: "POST", // Match the method to the backend
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email }), // Pass the email in the request body
      });

      const data = await res.json();

      if (res.status === 201) {
        setEmail("");
        setMessage("Password reset link sent to your email!");
        setMessageType("success"); // Success message type
      } else {
        setMessage(data.message || "There was an error sending the reset link.");
        setMessageType("error"); // Error message type
      }

      // Hide the message after 5 seconds
      setTimeout(() => {
        setMessage("");
        setMessageType(""); // Reset message type after message disappears
      }, 5000); // 5000ms = 5 seconds
    } catch (error) {
      console.error("Error sending reset link:", error);
      setMessage("Failed to send reset link. Please try again later.");
      setMessageType("error");

      // Hide the message after 5 seconds
      setTimeout(() => {
        setMessage("");
        setMessageType(""); // Reset message type after message disappears
      }, 3000); // 3000ms = 3 seconds
    }
  };

  return (
      <div className="password-reset-container">
        <div className="password-reset-card">
          <h2 className="password-reset-title">Reset Your Password</h2>
          <p className="password-reset-text">
            Enter your email address below, and we'll send you a link to reset your password.
          </p>

          {message && (
              <p className={`message ${messageType === 'success' ? 'success' : 'error'}`}>
                {message}
              </p>
          )}

          <div className="auth-input-group">
            <input
                className="auth-input"
                type="email"
                value={email}
                onChange={setVal}
                placeholder="Enter your email"
                required
            />
          </div>

          <button
              className="auth-submit-button"
              type="button"
              onClick={handleReset}
              disabled={!email.trim()} // Disable button if email is empty
          >
            Send Reset Link
          </button>
        </div>
      </div>
  );
}
